export const Z_INDEX_DRAWER = 0 // overriding the default MUI drawer z-index value

export const Z_INDEX_APP_FOOTER = 100

export const Z_INDEX_COOKIE_BANNER = 200

export const Z_INDEX_STYLED_TOOLTIP_TEXT = 0
export const Z_INDEX_STYLED_TOOLTIP_HIGHLIGHT = -1
